import React, { useEffect } from 'react';
import { CheckCircle, AlertCircle, X } from 'lucide-react';
import {
  ToastContainer,
  Toast,
  ToastIcon,
  ToastContent,
  ToastMessage,
  ToastCloseButton
} from './Toast.styles';

const ToastComponent = ({ toast, onClose }) => {
  useEffect(() => {
    if (toast.autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, toast.duration || 3000);

      return () => clearTimeout(timer);
    }
  }, [toast.autoClose, toast.duration, onClose]);

  return (
    <Toast type={toast.type}>
      <ToastIcon type={toast.type}>
        {toast.type === 'success' ? <CheckCircle size={20} /> : <AlertCircle size={20} />}
      </ToastIcon>
      <ToastContent>
        <ToastMessage>{toast.message}</ToastMessage>
      </ToastContent>
      <ToastCloseButton onClick={onClose}>
        <X size={16} />
      </ToastCloseButton>
    </Toast>
  );
};

export default ToastComponent;
